module.exports = __webpack_public_path__ + "static/img/redbag@2x.a3089df.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/activity/ZBActivity/redbag@2x.png
// module id = P0CH
// module chunks = 70